'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("webSocketService", function ($session, $location, $notifications, UUID) {
  var URL;

  // Pour identifier chaque conection pour un même authenticationToken (plusieurs tabs par exemple)
  var webSocketUniqueId = UUID();
  var webSocket;
  var reConnectionDelay;
  var _connect = function connect() {
    console.log("Tentative de connexion du webSocket");
    if ($session.getEnvironment()) {
      URL = $session.getEnvironment() === 'local' ? "ws://localhost:8080/ws/server" : "wss://" + $location.host() + "/ws/server";
      URL += "/" + webSocketUniqueId;
    } else {
      // Tentative de connection dans 1s
      setTimeout(_connect, 1000);
    }
    if (URL) {
      webSocket = new WebSocket(URL);
      webSocket.addEventListener("open", function (event) {
        console.log("WebSocket connecté");
        reConnectionDelay = 1000;
      });
      webSocket.addEventListener("close", function (event) {
        console.log("WebSocket déconnecté");
        // Tentative de reconnection tous les 1s, puis 2s, puis 4s, puis 8s, puis toutes les 10s
        setTimeout(_connect, Math.min(1000, reConnectionDelay += reConnectionDelay));
      });
      webSocket.addEventListener("message", function (event) {
        $notifications.info(event.data);
      });
    }
  };
  return {
    connect: _connect
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/webSocketService.js
// module id = 2885
// module chunks = 13